import { ReactElement, useState, useEffect } from 'react';
import { tile } from '@interfaces/interfaces';
import { Field, getIn, useFormikContext } from 'formik';
import { TileRadioAccessible, Alert, DateInput } from '@components';
import gridStyles from '@pages/forms/Grid.module.scss';
import { iInfringementExtensionFormValues } from '@services/InfringementExtensionService';
import InfringementExtensionStep3AlertContent1 from '@components/Content/AlertContent/InfringementExtensionStep3AlertContent1';
import InfringementExtensionStep3AlertContent2 from '@components/Content/AlertContent/InfringementExtensionStep3AlertContent2';
import { getBasicInfo } from '@api/APIServices';

import { FormType } from '@constants/forms';
import styles from './InfringementExtStep3.module.scss';
import InfoIcon from '../../../../images/info.svg';

function InfringementExtStep3(): ReactElement {
  const [loading, setLoading] = useState(true);
  const context = useFormikContext();
  const YesValue = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
  ];

  const { values, touched }: { values: iInfringementExtensionFormValues; touched: any } = useFormikContext();
  const { WasHandedInPerson } = values;
  const [isTimeOfOffenceEnabled, setTimeOfOffenceEnabled] = useState(false);

  useEffect(() => {
    const getTicketInfo = async (formikContext: any): Promise<void> => {
      setLoading(true);
      getBasicInfo(formikContext.values.OBLIGATION_NUMBER, FormType.INFRINGEMENTEXTENSION).then((responseBody) => {
        if (responseBody) {
          context.setFieldValue('ObligationStatus', responseBody.ObligationStatus);
          context.setFieldValue('TicketType', responseBody.TicketType);
          context.setFieldValue('Status', responseBody.Status);
          context.setFieldValue('DebtorType', responseBody.DebtorType);
          if (responseBody.DebtorType === 'Individual') {
            context.setFieldValue('isDebtorTypeIndividual', true);
          }
          if (responseBody.DebtorType === 'Company') {
            context.setFieldValue('isDebtorTypeCompany', true);
          }
          context.setFieldValue('OffenceCode', responseBody.OffenceCode);
          if (responseBody.TicketType) {
            if ((responseBody.TicketType.split('_')[1] === '1B' || responseBody.TicketType.split('_')[1] === '2A') && values.isOfficerIssued) {
              context.setFieldValue('isHandedDownInPersonFieldRequired', true);
              setTimeOfOffenceEnabled(true);
            }
          }
        }
      });
      setLoading(false);
    };
    getTicketInfo(context);
  }, []);

  useEffect(() => {
    if (getIn(touched, 'OFFENCE_FIND_OUT_DATE')) {
      context.setFieldTouched('OFFENCE_FIND_OUT_DATE');
    }
  }, [values.OFFENCE_FIND_OUT_DATE]);

  return (
    <>
      {!loading && (
        <div className={gridStyles.form}>
          <span className="vfH2">Before you continue?</span>
          <div className={gridStyles.gridColFull}>
            <div className={styles.col}>
              <Field
                component={DateInput}
                name="OFFENCE_FIND_OUT_DATE"
                title="What date did you find out about the fine?"
                isMandatory
                maxDate={new Date()}
                minDate={new Date().setDate(new Date().getDate() - 14)}
                // autocomplete="off"
              />
              {values.OFFENCE_FIND_OUT_DATE !== null
              && (values.OFFENCE_FIND_OUT_DATE < new Date(new Date().setDate(new Date().getDate() - 15)) || values.OFFENCE_FIND_OUT_DATE > new Date()) && (
                <Alert
                  message={<InfringementExtensionStep3AlertContent1 />}
                  theme="info"
                  title="Based on the information you have provided, you are not eligible to apply for an infringement extension."
                  icon={InfoIcon}
                />
              )}
            </div>
          </div>
          {isTimeOfOffenceEnabled && (
            <div className={gridStyles.gridColFull}>
              <div className={styles.col}>
                <Field
                  name="WasHandedInPerson"
                  title="Were you handed an infringement notice by an officer at the time of the offence?"
                  component={TileRadioAccessible}
                  tileData={TILE_DATA}
                  orientationRow
                  isMandatory
                />
                {WasHandedInPerson === 'true' && (
                  <Alert
                    message={<InfringementExtensionStep3AlertContent2 />}
                    theme="info"
                    title="Based on the information you have provided, you are not eligible to apply for an infringement extension."
                    icon={InfoIcon}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default InfringementExtStep3;
